// import { useEffect, useState } from 'react';
// import { axiosWrapper } from '../../../../../hooks/axios';
import { gql, useQuery } from '@apollo/client';
import { Query } from '../../../../../generated/graphqlModels';

const query = gql`
  query getStudyGroupContentSettings($studyGroupId: ID!) {
    studyGroup(pk: $studyGroupId) {
      usesNewRenderer
      usesMaxWidth
    }
  }
`;

const useStudyGroupContentSettings = (studyGroupId: string) => {
  const { loading, error, data } = useQuery<Query>(query, {
    variables: { studyGroupId },
    skip: studyGroupId == null,
  });
  if (studyGroupId == null) {
    return {
      usesNewRenderer: true,
      usesMaxWidth: !error && data && data.studyGroup.usesMaxWidth,
      loading,
    };
  }

  return {
    usesNewRenderer: !error && data && data.studyGroup.usesNewRenderer,
    usesMaxWidth: !error && data && data.studyGroup.usesMaxWidth,
    loading,
  };
};

export default useStudyGroupContentSettings;
